import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Teacher, TeacherState } from '../types/teacher';
import { Admin,AdminState } from '../types/admin';

const initialState: AdminState = {
  admins: [],
  loading: false,
  error: null,
};

const adminSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    fetchadminsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchadminsSuccess: (state, action: PayloadAction<Admin[]>) => {
      state.loading = false;
      state.admins = action.payload;
    },
    fetchadminsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addadminsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addadminSuccess: (state, action: PayloadAction<Admin>) => {
      state.loading = false;
      state.admins.push(action.payload);
    },
    addadminFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateadminStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateadminSuccess: (state, action: PayloadAction<Admin>) => {
      state.loading = false;
      state.admins = state.admins.map((admin) =>
        admin.id === action.payload.id ? action.payload : admin
      );
    },
    updateadminFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteadminStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteadminSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.admins = state.admins.filter((admin) => admin.id !== action.payload);
    },
    deleteadminFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchadminsStart,
  fetchadminsSuccess,
  fetchadminsFailure,
  addadminsStart,
  addadminSuccess,
  addadminFailure,
  updateadminStart,
  updateadminSuccess,
  updateadminFailure,
  deleteadminStart,
  deleteadminSuccess,
  deleteadminFailure,
} = adminSlice.actions;

export default adminSlice.reducer;